import useCapabilities, {
  DOMAIN,
  PERMISSION,
  useHasCapabilityBool,
  useRequireCapability
} from "@/hooks/useCapabilities";

export function usePersonCareerCapability() {
  const { loaded } = useCapabilities();
  const canViewPersonCareer = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonCareer
  });

  return {
    loaded,
    canViewPersonCareer
  };
}

/** Capability check for career employment/governance/awards routes. Denied users are redirected by useRequireCapability. */
export function usePersonCareerAccess() {
  const { loaded, canViewPersonCareer } = usePersonCareerCapability();

  useRequireCapability({ domain: DOMAIN.PEOPLE, permission: PERMISSION.viewPersonCareer });

  return {
    loaded,
    canViewPersonCareer
  };
}
